import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class App extends Component {
  constructor() {
    super();
    this.state = {
      sourceData: [], // To store processed source data
      loading: true, // To manage loading state
      error: null, // To handle errors
    };
  }

  // Function to fetch source data from the API
 fetchSourceData = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users`, {
      headers: {
        'X-Auth-Token': token,
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    
    const data = await response.json();
    this.processSourceData(data.orders);
  } catch (error) {
    this.setState({
      error: `Failed to load source data: ${error.message}`,
      loading: false,
    });
  }
};

  // Function to process and format the source data
  processSourceData = (orders) => {
    const sourceCount = {};

    // Count the occurrences of each source (case insensitive), skip null or invalid sources
    orders.forEach(order => {
      const source = order.source;
      if (source && source.trim() !== '') { // Ensure source is valid (not null, undefined, or empty)
        const normalizedSource = source.toLowerCase(); // Normalize source to lower case
        if (sourceCount[normalizedSource]) {
          sourceCount[normalizedSource]++;
        } else {
          sourceCount[normalizedSource] = 1;
        }
      }
    });

    // Get the top 20 sources by count
    const sortedSources = Object.keys(sourceCount)
      .map(source => ({ label: source, count: sourceCount[source] }))
      .sort((a, b) => b.count - a.count) // Sort by count in descending order
      .slice(0, 20); // Limit to top 20

    // Calculate total count of sources
    const totalCount = sortedSources.reduce((acc, source) => acc + source.count, 0);

    // Calculate percentage for each source and prepare the data for chart
    const sourcesWithPercentages = sortedSources.map(source => ({
      label: source.label,
      count: source.count, // Actual count
      y: ((source.count / totalCount) * 100).toFixed(2), // Calculate percentage
    }));

    this.setState({
      sourceData: sourcesWithPercentages,
      loading: false,
    });
  };

  componentDidMount() {
    this.fetchSourceData(); // Fetch source data when the component mounts
  }

  render() {
    const { sourceData, loading, error } = this.state;

    // If loading, display loading message
    if (loading) {
      return <div>Loading...</div>;
    }

    // If error, display error message
    if (error) {
      return <div>{error}</div>;
    }

    // Chart options
    const options = {
      theme: "dark1", // Use "dark1" for black and grey theme
      animationEnabled: true,
      backgroundColor: "transparent",
      exportEnabled: false, // Disable export button
      title: {
        text: "Top Sources", // Title changed to "Top Sources"
        fontColor: "#fff", // Set title font color to white
      },
      padding: {
        top: 20,
        bottom: 20,
        left: 40,
        right: 40,
      },
      data: [{
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: "{label}: <strong>({count} sources)</strong>", // Show percentage and actual count in tooltip
        indexLabel: "{label}: {y}%", // Show percentage and actual count on pie chart
        indexLabelPlacement: "inside",
        indexLabelFontSize: 12,
        dataPoints: sourceData.map(data => ({
          label: data.label,
          y: data.y,
          count: data.count, // Include the actual count in the data
        })),
      }]
    };

    return (
      <div style={{
        padding: '30px',
        backgroundColor: 'black', // Background color for the entire container
        borderRadius: '15px',
        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.6)', // Enhanced shadow effect for the container
      }}>
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default App;
